import { pathes as marketplacePathes} from '@/modules/marketplace/routing/pathes';
import { pathes as abtTicketPathes} from '@/modules/abt-ticket/routing/pathes';
import { pathes as feedPwaPathes} from '@/modules/feed-pwa/routing/pathes';
import { pathes as questionarePwaPathes } from '@/modules/questionnaire-pwa/routing/pathes';
import { pathes as specialGroupsPathes } from '@/modules/special-groups/routing/pathes';
import { pathes as taxiDriverPathes} from '@/modules/taxi-driver/routing/pathes';
import { pathes as taxiPassengerPathes } from '@/modules/taxi-passenger/routing/pathes';
import { pathes as technicalDiagnosisPathes } from '@/modules/technical-diagnosis/routing/pathes';
import { pathes as vehicleProfilePathes } from '@/modules/vehicle-profile/routing/pathes';
import { pathes as vodPlatformPathes} from '@/modules/vod-platform/routing/pathes';
import { pathes as operatingServicesPathes } from '@/modules/operating-service/routing/pathes';
import { pathes as driverPwaPathes} from '@/modules/driver-pwa/routing/pathes';
const pathes =  {
    abtTicket: abtTicketPathes.BASE_PATH,
    marketplace: marketplacePathes.BASE_PATH,
    feedPwa: feedPwaPathes.BASE_PATH,
    questionarePwa: questionarePwaPathes.BASE_PATH,
    specialGroups: specialGroupsPathes.BASE_PATH,
    taxiDriver: taxiDriverPathes.BASE_PATH,
    taxiPassenger: taxiPassengerPathes.BASE_PATH,
    technicalDiagnosis: technicalDiagnosisPathes.BASE_PATH,
    vehicleProfile: vehicleProfilePathes.BASE_PATH,
    vodPlatform: vodPlatformPathes.BASE_PATH,
    operatingServices: operatingServicesPathes.BASE_PATH,
    driverPwa: driverPwaPathes.BASE_PATH,
}

export default pathes;